(function () {
  "use strict";

  angular.module("sempraWebapp").component("logsHistory", {
    templateUrl: "app/facilityKarcherDetails/logsHistory/logsHistory.html",
    controller: logsHistory,
    bindings: {
      deviceKey: "<"
    },
    controllerAs: "vm"
  });

  function logsHistory(
    dashboardKarcherActions,
    $translate,
    deviceActions,
    fromArrayToPathParam,
    layoutActions,
    helperService
  ) {
    var vm = this;
    vm.selectedPoints = "";
    vm.placeHolderText = $translate.instant("SELECT_POINTS_TO_SEARCH");
    // Grid data
    vm.logsOrderBy = "dateTime";
    vm.logsOrder = "desc";
    vm.logsPage = 1;
    vm.logsTotal = 0;
    vm.logsPageSize = 10;
    vm.logsPageOptions = [5, 10, 15, 50, 100];
    vm.pagerTranslations = {
      page: $translate.instant("GRID_PAGER_PAGE"),
      rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
      of: $translate.instant("GRID_PAGER_PAGE_OF")
    };

    vm.$onInit = function () {
      if (vm.deviceKey) {
        refreshHistoryLogList();
      }
    };

    vm.$onChanges = function () {
      if (vm.deviceKey) {
        refreshHistoryLogList();
        getDeviceList();
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.logsPage = page;
      vm.logsPageSize = limit;
      refreshHistoryLogList();
    };

    vm.sortChanged = function (order) {
      var orderQuery = getOrderObject(order);
      vm.logsOrderBy = orderQuery.orderBy;
      vm.logsOrder = orderQuery.order;
      refreshHistoryLogList();
    };

    vm.selectedLogs = function (ids) {
      vm.selectedPoints = ids;
    };

    vm.clearPointsInput = function () {
      vm.selectedPoints = "";
    };

    vm.searchLogs = function () {
      refreshHistoryLogList();
    };

    vm.refreshLogPage = function() {
      refreshHistoryLogList();
    }

    function refreshHistoryLogList() {
      layoutActions.showLoader();
      deviceActions
        .getHistoryOfActuatedPointsByDeviceKey(
          vm.deviceKey,
          fromArrayToPathParam.createPath(vm.selectedPoints, "pointId="),
          vm.logsPage - 1,
          vm.logsPageSize,
          helperService.orderByRemover(vm.logsOrderBy),
          vm.logsOrder
        )
        .then(function (data) {
          if (data.content.length === 0) {
            vm.logsList = [];
            vm.logsList.push({
              dateTime: $translate.instant("NOTHING_TO_DISPLAY"),
              displayNotResolve: true
            });
          } else {
            vm.logsList = data.content;
          }
          vm.logsTotal = data.totalElements;
          layoutActions.hideLoader();
        });
    }

    function getDeviceList() {
      deviceActions
        .getPointsListByDeviceKey(vm.deviceKey)
        .then(function (deviceList) {
          vm.pointList = deviceList;
        });
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }
  }
})();
